import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import Button from './Button';
import toHref, { getApartment, getSite } from '../tools/fetcher';
import ProductTitle from './ProductTitle';
import ProductBanner from './ProductBanner';
import ProductSlider from './ProductSlider';
import { classNames } from '../tools/helpers';
import GallerySlider from './GallerySlider';

export default function Product({ className, classNameSlider, innerWidth }) {
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });
    const [products, setProducts] = useState([]);
    const pathImg = (imgName) =>
        toHref(
            `/wp-content/plugins/react-plugin/react-app/build/assets/facility/${imgName}.svg`,
        );

    const RenderProduct = useCallback(
        ({ product }) => (
            <div className="bg-white p-6 rounded-[20px] flex sm:items-start flex-col sm:flex-row sm:gap-8">
                <div className={'flex justify-start items-center gap-6'}>
                    {product.image_gallery && (
                        <div className={'w-[72px] sm:w-[160px] relative'}>
                            <GallerySlider images={product.image_gallery} />
                        </div>
                    )}
                    <div className={'block sm:hidden leading-[24px]'}>
                        <h1 className={'font-bold text-base'}>
                            <a
                                href={product?.link}
                                className={'!no-underline '}
                            >
                                {product?.title?.rendered}
                            </a>
                        </h1>
                        <p className={'text-apart-black-50 text-base'}>
                            {product?.apartment_details?.address}
                        </p>
                    </div>
                </div>
                <div className={'flex-1'}>
                    <div className={'hidden sm:block'}>
                        <h1 className={'font-bold text-[20px]'}>
                            <a
                                href={product?.link}
                                className={'!no-underline '}
                            >
                                {product?.title?.rendered}
                            </a>
                        </h1>
                        <p className={'text-apart-black-50 text-[20px]'}>
                            {product?.apartment_details?.address}
                        </p>
                    </div>

                    <ul className="grid grid-cols-2 gap-y-4 mt-4 text-apart-black-50">
                        {product?.apartment_details?.size && (
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('home')}
                                    alt={'bg-size'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>
                                    {product?.apartment_details?.size} meter
                                </span>
                            </li>
                        )}
                        {product?.apartment_details?.wifi === 'on' && (
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('wifi')}
                                    alt={'bg-wifi'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>Free Wifi</span>
                            </li>
                        )}
                        {product?.apartment_details?.bedrooms && (
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('bed')}
                                    alt={'bg-bedrooms'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>
                                    {product?.apartment_details?.bedrooms} Kasur
                                </span>
                            </li>
                        )}
                        {product?.apartment_details?.bathroom === 'on' && (
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('shower')}
                                    alt={'bg-bathroom'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>
                                    K. Mandi Dalam
                                </span>
                            </li>
                        )}
                        {product?.apartment_details?.kitchen === 'on' && (
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('kitchen')}
                                    alt={'bg-kitchen'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>Dapur</span>
                            </li>
                        )}
                        {product?.apartment_details?.furnished === 'on' && (
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('furnished')}
                                    alt={'bg-furnished'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>Furnished</span>
                            </li>
                        )}
                        {product?.apartment_details?.for_men === 'on' && (
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('bed')}
                                    alt={'bg-for_men'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>Khusus Putra</span>
                            </li>
                        )}
                        {product?.apartment_details?.for_ladies === 'on' && (
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('bed')}
                                    alt={'bg-for_ladies'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>Khusus Putri</span>
                            </li>
                        )}
                    </ul>
                    <div
                        className={
                            'text-[20px] leading-[28px] mt-4 flex gap-2 items-center'
                        }
                    >
                        <span className={'font-bold'}>
                            Rp{' '}
                            {(+product.apartment_details
                                .per_month).toLocaleString('id-ID')}
                        </span>{' '}
                        <span
                            className={
                                'text-[14px] sm:text-[20px] text-apart-black-50 font-normal'
                            }
                        >
                            per bulan
                        </span>
                    </div>
                    <Button
                        type={'a'}
                        target={'_blank'}
                        href={product?.apartment_details?.link_url}
                        className={
                            '!no-underline bg-apart-green-50 w-full mt-6'
                        }
                    >
                        Hubungi Kami
                    </Button>
                </div>
            </div>
        ),
        [],
    );

    useEffect(() => {
        getApartment().then((result) => {
            if (!result?.code) {
                setProducts(result);
            }
        });
        console.log('RERENDER');
    }, [setProducts]);

    const traverse = useMemo(() => {
        if (data?.product_banner.checked === 'no') {
            return 'bottom';
        }
        if (products.length >= 3) {
            return 'bottom';
        }
        if (products.length >= 1) {
            return 'top';
        }

        return 'kosong';
    }, [data, products]);

    return (
        <>
            <div className={className}>
                <div
                    className={classNames(
                        'grid lg:grid-cols-2 gap-8 lg:gap-10',
                        innerWidth,
                    )}
                >
                    <div className={'col-span-2'}>
                        <ProductTitle products={products} />
                    </div>
                    {traverse === 'top' && (
                        <>
                            <div className={'col-span-2 lg:col-span-1'}>
                                <ProductBanner />
                            </div>
                            <div className="rounded-[20px] overflow-y-auto col-span-2 lg:col-span-1 grid gap-4 lg:flex lg:flex-col md:gap-10">
                                {products.map((product, index) => (
                                    <RenderProduct
                                        key={index}
                                        product={product}
                                    />
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
            {traverse === 'bottom' && (
                <div className={classNameSlider}>
                    <div
                        className={classNames(
                            'mt-8 lg:mt-10 relative',
                            innerWidth,
                        )}
                    >
                        <ProductSlider />
                    </div>
                </div>
            )}
        </>
    );
}
